import React, { FunctionComponent } from 'react';

import { CommonError } from 'src/components/common-error';
import { i18n } from 'src/i18n';
import { monkeyImageProps } from 'src/resources/images';
import { DataLayerEcomErrors } from 'src/types/data-layer-event-object';

export const PageProductNotAvailable: FunctionComponent = () => (
  <CommonError
    title={i18n.page.error.productNotAvailable.title}
    subtitles={[i18n.page.error.productNotAvailable.mainSubtitle]}
    image={monkeyImageProps}
    hideCustomerServiceText={true}
    dataLayerErrorMessage={DataLayerEcomErrors.OUT_OF_STOCK_ERROR}
  />
);
